import { ReloadOutlined } from '@ant-design/icons';

import usePullToRefresh from '~/hooks/usePullToRefresh';

import { Indicator } from './PullToRefresh.styled';

export default function PullToRefresh() {
  const { pull, refreshing, threshold } = usePullToRefresh();

  if (!pull && !refreshing) return null;

  const progress = Math.min(pull / threshold, 1);

  return (
    <Indicator aria-hidden style={{ opacity: progress, transform: `translate(-50%, ${pull}px)` }}>
      {refreshing ? <ReloadOutlined spin /> : <ReloadOutlined rotate={progress * 360} />}
    </Indicator>
  );
}
